<div class="p-2 mat-elevation-z0" id="sessionTimeout">
    <mat-card-title class="text-lg font-semibold flex items-center ">
        <mat-icon class="mb-1" svgIcon="heroicons_outline:exclamation-circle" color="warn"></mat-icon>
        Session Timeout
    </mat-card-title>
    <mat-card-content >
        <p class="mb-3 ml-3 font-medium">{{data}}</p>
    </mat-card-content>
    <mat-card-actions class="flex justify-end space-x-3">
        <button mat-flat-button color="warn" (click)="logout()">Logout</button>
        <button mat-flat-button color="primary" (click)="stay()">Stay Signed-In</button>
    </mat-card-actions>
</div>